import { SDK_FontSizes } from "@quickpoint.me/shared";
import { FilterInterface } from "../@types/viewerati";

let fontSizes: SDK_FontSizes;

function interpolateFontSizes(filter: FilterInterface): FilterInterface {
  if (!filter) return filter;
  if (filter.fontSizes) fontSizes = filter.fontSizes;
  // list of filter modifiers that define colors

  for (const [key, value] of Object.entries(filter)) {
    // @ts-ignore
    if (key === "fontSize" && fontSizes[value]) {
      // @ts-ignore
      filter[key] = fontSizes[value];
    }

    // @ts-ignore
    if (typeof filter[key] === "object") {
      // @ts-ignore
      interpolateFontSizes(filter[key]);
    }
  }
  return filter;
}

export default interpolateFontSizes;
